import { useEffect, useState } from "react";

export function usePlaybackSpeed(
  refPlayer: React.RefObject<HTMLAudioElement>,
  speeds = [1, 1.25, 1.5, 2]
) {
  const [playbackSpeed, setPlaybackSpeed] = useState(speeds[0]);

  const cycleSpeed = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setPlaybackSpeed((prev) => {
      const idx = speeds.indexOf(prev);
      return speeds[(idx + 1) % speeds.length];
    });
  };

  useEffect(() => {
    if (refPlayer.current) {
      refPlayer.current.playbackRate = playbackSpeed;
    }
  }, [playbackSpeed, refPlayer]);

  return { playbackSpeed, cycleSpeed };
}
